import { render, staticRenderFns } from "./GoalPlannerNotes.vue?vue&type=template&id=1c5a2c80"
import script from "./GoalPlannerNotes.ts?vue&type=script&lang=ts&external"
export * from "./GoalPlannerNotes.ts?vue&type=script&lang=ts&external"
import style0 from "./GoalPlannerNotes.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports